module.exports = __webpack_public_path__ + "static/img/47成都幼教.b132da9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/47成都幼教.jpg
// module id = 2l7Y
// module chunks = 0